import * as React from "react";

import {
    Button,
    createStyles,
    Dialog,
    DialogActions,
    Theme,
    withStyles,
} from "@material-ui/core";

import MuiDialogContent from "@material-ui/core/DialogContent";

import i18n from "../../services/localization/i18n";
import { CloseableDialogTitle } from "../shared/CloseableDialog";
import UserProfile from "./UserProfile";
import { inject, observer } from "mobx-react";
import { PredefinedStoreName } from "../enums/PredefinedStoreName";
import { UserRequestInfo } from "../../services/auth/UserRequestInfo";
import signaling from "../../services/site/signaling";
import { IContextStoreProps } from "../../stores/IContextStoreProps";
import { IConfigStoreProps } from "../../stores/IConfigStoreProps";

import meDataService from "../../services/auth/MeDataService";
import { UserSummaryInfo } from "../../services/auth/UserSummaryInfo";

const styles = (theme: Theme) => createStyles({
    actions: {

    },
    closeButton: {
        color: theme.palette.grey[500],
        position: "absolute",
        right: theme.spacing(),
        top: theme.spacing(),
    },
    dialog: {
    },
    dialogContent: {
    },
    leftSmallIcon: {
        fontSize: 20,
        marginRight: theme.spacing(),
    },
    root: {
        paddingBottom: 0,
    },
});

const DialogContent = withStyles((theme: Theme) => ({
    root: {
      padding: theme.spacing(2),
    },
}))(MuiDialogContent);

interface IOptionsDialogProps {

    classes?: {
        actions: string;
        closeButton: string;
        dialog: string;
        dialogContent: string;
        leftSmallIcon: string;
        root: string;
    };
    open: boolean;
    onClose: () => void;
}

interface IOptionsDialogState {
    user: UserRequestInfo;
}


@inject(PredefinedStoreName.CONFIG)
@inject(PredefinedStoreName.CONTEXT)
@observer
class OptionsDialog extends React.Component<IOptionsDialogProps & IContextStoreProps & IConfigStoreProps, IOptionsDialogState> {

    private updateTask: Promise<UserSummaryInfo | void> = Promise.resolve();

    constructor(props: IOptionsDialogProps & IContextStoreProps & IConfigStoreProps) {
        super(props);

        this.state = {
            user: {}
        }
    }

    public render() {

        const {classes} = this.props;

        return <Dialog  open={this.props.open}
                        onClose={this.props.onClose}
                        aria-labelledby="form-dialog-title"
                        className={classes!.dialog}>

            <CloseableDialogTitle id="form-dialog-title" onClose={this.props.onClose}>
                { i18n.t("options_tab_profile") }
            </CloseableDialogTitle>

            <DialogContent className={classes!.dialogContent}>
                <UserProfile onUserProfileChanged={this.onUserProfileChanged}
                             onSubmit={this.onUserProfileSubmit} />
            </DialogContent>

            <DialogActions>
                <Button onClick={this.props.onClose} variant="outlined" fullWidth={true}>
                    { i18n.t("consentdialog_button_cancel") }
                </Button>

                <Button onClick={this.onAccept} variant="contained" color="primary"  fullWidth={true}>
                    { i18n.t("consentdialog_button_ok") }
                </Button>
            </DialogActions>

        </Dialog>;
        
    }

    private onUserProfileChanged = (user: UserRequestInfo, submit?: boolean) => {

        if (!submit) {
            this.setState({user});
        } else {
            this.setState({
                user,
            }, this.onUserProfileSubmit);
        }

    }

    private onUserProfileSubmit = () => {
        const {configStore} = this.props;

        this.updateTask = meDataService.patchAsync(this.state.user)
            .then((user) => {
                configStore!.setMe(user);

                signaling.notifyProfileChange();

            });
    }

    private onAccept = () => {
        this.updateTask.then(() => this.props.onClose());
    }
}

export default withStyles(styles, {withTheme: true})(OptionsDialog);
